import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=31c8b27b&scoped=true&lang=pug&"
import script from "./ModalMessage.vue?vue&type=script&lang=ts&"
export * from "./ModalMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=31c8b27b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8b27b",
  null
  
)

export default component.exports